// extracted by mini-css-extract-plugin
export default {"productGallery":"SH-z","inQuickShop":"TH-z"};